import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import RegularText from '../Text/RegularText';

//= ========================================================================

const RadioButton = ({
  key_configuration, text, isSelected, onPress, threeInARow,
}) => {
  const myStyles = {
    container: {
      flexDirection: 'row',
      marginEnd: threeInARow ? 24 : 45,
    },
    radioButton: {
      width: 19,
      height: 19,
      borderRadius: 9.5,
      border: isSelected ? 'solid 5px #008cff' : 'solid 2px #e2e8f0',
      marginEnd: 5,
    },
  };

  return (
    <TouchableOpacity
      key={key_configuration}
      style={myStyles.container}
      onPress={onPress}
    >
      <View style={myStyles.radioButton} />
      <RegularText>{text}</RegularText>
    </TouchableOpacity>
  );
};
export default RadioButton;
